
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/treats",
      function () {
        return require("private-next-pages/treats.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/treats"])
      });
    }
  